import { FormEvent, useState } from 'react';
import PageMeta from '../../components/SEO/PageMeta';
import { sendContactMessage } from '../../api/contactClient';
import styles from './LegalPage.module.css';

const initialForm = {
  name: '',
  email: '',
  subject: '',
  message: '',
};

export default function ContactUsPage() {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    setStatus(null);
    setError(null);

    try {
      await sendContactMessage(form);
      setForm(initialForm);
      setStatus('Thanks, your message has been received. We will review it soon.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to send your message right now.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageMeta
        title="Contact Us"
        description="Contact SaveItPro Media Converter for support, privacy, legal, advertising, or partnership questions."
        path="/contact-us"
      />

      <article className={styles.page}>
        <header className={styles.hero}>
          <h1>Contact Us</h1>
          <p>
            Questions about image conversion, privacy, advertising, or business use? Send a message
            and include enough detail for us to understand the request.
          </p>
        </header>

        <div className={styles.contactGrid}>
          <section className={styles.contactCard}>
            <h2>Support topics</h2>
            <p>
              Use this form for conversion issues, broken downloads, privacy requests, legal
              notices, partnership questions, and general feedback about SaveItPro.
            </p>
          </section>

          <section className={styles.contactCard} aria-labelledby="contact-form-heading">
            <h2 id="contact-form-heading">Send a message</h2>
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.field}>
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  name="name"
                  value={form.name}
                  required
                  maxLength={120}
                  onChange={(event) => setForm({ ...form, name: event.target.value })}
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  required
                  maxLength={200}
                  onChange={(event) => setForm({ ...form, email: event.target.value })}
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="subject">Subject</label>
                <input
                  id="subject"
                  name="subject"
                  value={form.subject}
                  required
                  maxLength={160}
                  onChange={(event) => setForm({ ...form, subject: event.target.value })}
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={form.message}
                  required
                  maxLength={4000}
                  onChange={(event) => setForm({ ...form, message: event.target.value })}
                />
              </div>

              {status && <p className={styles.status}>{status}</p>}
              {error && <p className={styles.error}>{error}</p>}

              <button type="submit" className={styles.submit} disabled={loading}>
                {loading ? 'Sending...' : 'Send message'}
              </button>
            </form>
          </section>
        </div>
      </article>
    </>
  );
}
